import {TransitionState} from '../FadeTransition';

export const getDisplayedElementAfterTransition = (
  container: HTMLElement,
  testId: string,
) => {
  return container.querySelector(
    `[data-view-state="${TransitionState.FinalView}"] [data-testid="${testId}"]`,
  );
};

export const getDisplayedElementBeforeTransition = (
  container: HTMLElement,
  testId: string,
) => {
  return container.querySelector(
    `[data-view-state="${TransitionState.BeforeTransition}"] [data-testid="${testId}"]`,
  );
};
